import { Download, FileDown } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { exportPdf, exportCsv } from "@/lib/api";

export function downloadCsv(name, rows, cols) {
  exportCsv(`${name}-${new Date().toISOString().slice(0, 10)}.csv`, rows, cols);
}

export const PdfButton = ({ name, rows, cols, title, subtitle, summary, testid, label = "PDF" }) => (
  <Button data-testid={testid} size="sm" variant="outline" onClick={() => exportPdf(`${name}-${new Date().toISOString().slice(0, 10)}`, rows, cols, title, subtitle, summary).catch(() => toast.error("PDF download failed"))}>
    <FileDown className="mr-1 h-4 w-4" />{label}
  </Button>
);

export const CsvButton = ({ name, rows, cols, testid, title }) => (
  <div className="flex gap-2">
    <Button data-testid={testid} size="sm" variant="outline" onClick={() => downloadCsv(name, rows, cols)}><Download className="mr-1 h-4 w-4" />CSV</Button>
    <PdfButton testid={`${testid}-pdf`} name={name} rows={rows} cols={cols} title={title || name.replace(/-/g, " ").replace(/^\w/, (c) => c.toUpperCase())} />
  </div>
);

export function Bar({ label, value, max, hint, testid }) {
  return (
    <div data-testid={testid} className="space-y-1">
      <div className="flex justify-between text-xs"><span className="font-semibold text-zinc-700">{label}</span><span className="font-bold text-zinc-900">{hint ?? value}</span></div>
      <div className="h-2 rounded-full bg-zinc-100"><div className="h-2 rounded-full bg-[#8B7356] transition-[width] duration-500" style={{ width: `${max && value ? Math.max(3, (100 * value) / max) : 0}%` }} /></div>
    </div>
  );
}
